export const extractCountryCode = (lang) => {
  const [languageCode, countryCode] = lang?.split('-') || [];
  const formattedLanguageCode = languageCode?.toLowerCase() || '';

  if (!languageCode) {
    return 'cs';
  }

  if (formattedLanguageCode === 'en') {
    return countryCode?.toUpperCase() === 'US' ? 'en' : countryCode?.toLowerCase();
  }

  if (formattedLanguageCode === 'nl') {
    return formattedLanguageCode;
  }

  return formattedLanguageCode;
};
